import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQ } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="scroll-mt-24 bg-blush">
    <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="11" label="FAQ" color="bg-cyan" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Najczęstsze pytania
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10 space-y-4" data-testid="faq-accordion">
          {FAQ.map((item, i) => {
            const isPlaceholder = item.a.startsWith("[");
            return (
              <AccordionItem
                key={item.q}
                value={`faq-${i + 1}`}
                data-testid={`faq-item-${i + 1}`}
                className="rounded-2xl border-2 border-ink bg-white px-5 shadow-hard-sm sm:px-7"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-5 text-left text-base font-extrabold text-ink hover:no-underline sm:text-lg"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i + 1}`}
                  className={`pb-5 text-sm leading-relaxed sm:text-base ${
                    isPlaceholder ? "font-semibold text-ink/40" : "text-ink/75"
                  }`}
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
